import { useLocation } from "react-router-dom";
import { GenericLoader } from "./GenericLoader";
import LoadingScreen from "../loading-screen";

export const createMarketplaceLoader = (loaderConfig, sellerPageLoaderImage) => {
    if (!loaderConfig) return () => <LoadingScreen />;

    const MarketplaceLoaderComponent = () => {
        const { pathname } = useLocation();
        const isDashboardRoute = pathname.startsWith('/dashboard');

        return (
            <GenericLoader
                sellerPageLoaderImage={sellerPageLoaderImage}
                logo={loaderConfig.logo}
                width={loaderConfig.width}
                height={loaderConfig.height}
                color={isDashboardRoute ? undefined : loaderConfig.color}
            />
        );
    };

    MarketplaceLoaderComponent.displayName = 'MarketplaceLoader';

    return MarketplaceLoaderComponent;
}; 